import React, { useState, useMemo, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import TableContainer from "../../Components/Common/TableContainer";
import {
  Button,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  Label,
  Card,
  CardBody,
  FormGroup,
  Badge,
} from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import { toast, ToastContainer } from "react-toastify";
import { deleteAssignment, getAssignments } from "utils/apiService";
import AssignmentEditModal from "./AssignmentEditModal";
import DeleteModal from "Components/Common/DeleteModal";

function AssignmentsList() {
  document.title = "Assignments";
  const [assignments, setAssignments] = useState([]);
  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    fetchAssignments();
  }, []);

  const fetchAssignments = async () => {
    try {
      const data = await getAssignments();
      setAssignments(data.response);
      /* console.log("Fetched Assignmnets:", data.response); */
    } catch (err) {
      console.error("Failed to fetch students:", err);
    }
  };

  const handleEdit = (assignment: any) => {
    setSelectedAssignment(assignment);
    setEditModal(true);
  };

  const handleDelete = async (assignment: any) => {
    setSelectedAssignment(assignment);
    setDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      if (selectedAssignment) {
        await deleteAssignment((selectedAssignment as { id: number }).id);
        /*  await deleteAssignment(selectedAssignment.id); */
        toast.success("Assignment deleted successfully!");
        fetchAssignments();
      }
    } catch (error) {
      toast.error("Failed to delete assignment.");
      console.error("Delete Error:", error);
    } finally {
      setDeleteModal(false);
      setSelectedAssignment(null);
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "Sr No.",
        cell: (cellProps) => {
          // Adding 1 because array index starts from 0
          return cellProps.row.index + 1;
        },
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Student Name",
        accessorKey: "student_name",
      },
      {
        header: "Service Type",
        accessorKey: "service_name",
      },
      {
        header: "Question Description",
        accessorKey: "description",
      },
      {
        header: "File Submitted",
        accessorKey: "doc_base64",
        cell: (cellProps) => {
          const base64String = cellProps.row.original.doc_base64;

          if (!base64String) return "No file";
          const fileType = cellProps.row.original.doc_mimetype;

          const openFile = () => {
            const fileUrl = `data:${fileType};base64,${base64String}`;

            const newTab = window.open();

            if (newTab) {
              newTab.document.write(
                `<iframe src="${fileUrl}" width="100%" height="100%" style="border:none;"></iframe>`
              );
              newTab.document.close();
            }
          };

          return (
            <button className="btn btn-link text-primary" onClick={openFile}>
              📄 View File
            </button>
          );
        },
      },
      {
        header: "Due Date",
        accessorKey: "due_date",
        cell: (cellProps) => {
          const dateValue = cellProps.row.original.due_date;
          if (!dateValue) return "";

          const date = new Date(dateValue);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = String(date.getFullYear());

          return `${day}-${month}-${year}`;
        },
      },
      {
        header: "Answer Description",
        accessorKey: "answer_description",
      },
      {
        header: "Answer File",
        accessorKey: "answer_base64",
        cell: (cellProps) => {
          const base64String = cellProps.row.original.answer_base64;

          if (!base64String) return "No file";
          const fileType = cellProps.row.original.answer_mimetype;

          const openFile = () => {
            const fileUrl = `data:${fileType};base64,${base64String}`;

            const newTab = window.open();

            if (newTab) {
              newTab.document.write(
                `<iframe src="${fileUrl}" width="100%" height="100%" style="border:none;"></iframe>`
              );
              newTab.document.close();
            }
          };

          return (
            <button className="btn btn-link text-primary" onClick={openFile}>
              📄 View File
            </button>
          );
        },
      },
      {
        header: "Answer Submitted at",
        accessorKey: "answer_submitted_at",
        cell: (cellProps) => {
          const dateValue = cellProps.row.original.answer_submitted_at;
          if (!dateValue) return "";

          const date = new Date(dateValue);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = String(date.getFullYear());

          return `${day}-${month}-${year}`;
        },
      },
      {
        header: "Actions",
        accessorKey: "actions",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps) => {
          const assignment = cellProps.row.original;
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => handleEdit(assignment)}
              >
                <i className="mdi mdi-pencil font-size-18" />
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => handleDelete(assignment)}
              >
                <i className="mdi mdi-delete font-size-18" />
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={confirmDelete}
        onCloseClick={() => setDeleteModal(false)}
        message="Are you sure you want to delete this Assignmnet ? You won't be able to revert this!"
      />
      ;
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs breadcrumbItem="Assignments" />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={assignments}
                    isGlobalFilter={false}
                    isAddButton={false}
                    customPageSize={10}
                    isPagination={true}
                    tableClass="align-middle table-nowrap dt-responsive nowrap w-100"
                    theadClass="table-light"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
      <AssignmentEditModal
        isOpen={editModal}
        toggle={() => setEditModal(false)}
        assignment={selectedAssignment}
        refreshData={fetchAssignments}
      />
    </React.Fragment>
  );
}

export default AssignmentsList;
